import { detect } from 'detect-browser'

export const detectBrowser = () => {
  try {
    const browser = detect()
    return { name: browser?.name || 'unknown', version: browser?.version || 'unknown' }
  } catch (e) {
    return {
      name: 'unknown',
      version: 'unknown',
    }
  }
}
